import { filterActiveReceitasDespesas } from '@modules/financial-planning/utils/financial-planning-settings'

// Getters
export const calculadoraPgbl = (state) => {
  return state.calculadoraPgbl.data || []
}
export const pgblResult = (state) => {
  return state.calculadoraPgbl.result || {}
}
export const calculadoraPgblLoading = (state) => {
  return state.calculadoraPgbl.loading
}
export const calculadoraPgblLastUpdate = (state) => {
  return state.calculadoraPgbl.lastUpdate
}
export const transactions = (state) => {
  return state.transactions.data || []
}
export const transactionsLoading = (state) => {
  return state.transactions.loading
}
export const transactionsLastUpdate = (state) => {
  return state.transactions.lastUpdate
}
export const transactionsClientId = (state) => {
  return state.transactions.clientId
}
// Filtro persistido de Transações/Orçamentos. Default `{}` (nunca undefined).
export const filterOrcamentos = (state) => {
  return state.filterOrcamentos || {}
}
export const budgets = (state) => {
  return state.budgets.data || []
}
export const budgetsLoading = (state) => {
  return state.budgets.loading
}
export const budgetsLastUpdate = (state) => {
  return state.budgets.lastUpdate
}
export const budgetsClientId = (state) => {
  return state.budgets.clientId
}
export const goals = (state) => {
  return state.goals.data || []
}
export const goalsTotals = (state) => {
  return state.goals.totals || {}
}
export const goalsRemaining = (state) => {
  return state.goals.remaining || {}
}
export const goalsRaw = (state) => {
  return state.goals.raw || null
}
export const goalsLoading = (state) => {
  return state.goals.loading
}
export const goalsLastUpdate = (state) => {
  return state.goals.lastUpdate
}
export const goalsClientId = (state) => {
  return state.goals.clientId
}
export const patrimony = (state) => {
  return state.patrimony.data || []
}
export const patrimonyLoading = (state) => {
  return state.patrimony.loading
}
export const patrimonyLastUpdate = (state) => {
  return state.patrimony.lastUpdate
}
export const patrimonyClientId = (state) => {
  return state.patrimony.clientId
}
export const patrimonyGoalLinks = (state) => {
  return state.patrimonyGoalLinks.data || []
}
export const patrimonyGoalLinksLoading = (state) => {
  return state.patrimonyGoalLinks.loading
}
export const patrimonyGoalLinksLastUpdate = (state) => {
  return state.patrimonyGoalLinks.lastUpdate
}
export const patrimonyGoalLinksClientId = (state) => {
  return state.patrimonyGoalLinks.clientId
}
export const assetGoalLinks = (state) => {
  return state.assetGoalLinks.data || []
}
export const assetGoalLinksLoading = (state) => {
  return state.assetGoalLinks.loading
}
export const assetGoalLinksLastUpdate = (state) => {
  return state.assetGoalLinks.lastUpdate
}
export const assetGoalLinksClientId = (state) => {
  return state.assetGoalLinks.clientId
}
export const categories = (state) => {
  return state.categories.data || []
}
export const categoriesLoading = (state) => {
  return state.categories.loading
}
export const categoriesLastUpdate = (state) => {
  return state.categories.lastUpdate
}
export const subcategories = (state) => {
  return state.subcategories.data || []
}
export const subcategoriesLoading = (state) => {
  return state.subcategories.loading
}
export const subcategoriesLastUpdate = (state) => {
  return state.subcategories.lastUpdate
}
export const rules = (state) => {
  return state.rules.data || []
}
export const rulesLoading = (state) => {
  return state.rules.loading
}
export const rulesLastUpdate = (state) => {
  return state.rules.lastUpdate
}
export const rulesClientId = (state) => {
  return state.rules.clientId
}
export const investmentAccounts = (state) => {
  return state.investmentAccounts.data || []
}
export const investmentAccountsLoading = (state) => {
  return state.investmentAccounts.loading
}
export const investmentAccountsLastUpdate = (state) => {
  return state.investmentAccounts.lastUpdate
}
export const investmentAccountsClientId = (state) => {
  return state.investmentAccounts.clientId
}
export const investmentPortfolio = (state) => {
  return state.investmentPortfolio.data || {}
}
export const investmentPortfolioLoading = (state) => {
  return state.investmentPortfolio.loading
}
export const investmentPortfolioLastUpdate = (state) => {
  return state.investmentPortfolio.lastUpdate
}
export const investmentPortfolioClientId = (state) => {
  return state.investmentPortfolio.clientId
}
export const calculadoraPgblTableData = (state) =>
  state.calculadoraPgbl.tableData
export const calculadoraPgblHeaders = (state) => state.calculadoraPgbl.headers
export const calculadoraPgblDataDetails = (state) =>
  state.calculadoraPgbl.dataDetails
export const calculadoraPgblResultData = (state) =>
  state.calculadoraPgbl.resultData
export const calculadoraPgblLoadingSave = (state) =>
  state.calculadoraPgbl.loadingSave
export const calculadoraPgblLoadingSimulation = (state) => {
  return state.calculadoraPgbl.loadingSimulation
}
export const calculadoraPgblClients = (state) => {
  return state.calculadoraPgbl.clients || []
}
export const calculadoraPgblClientsLoading = (state) => {
  return state.calculadoraPgbl.clientsLoading
}
export const calculadoraPgblClientsNameMap = (state) => {
  return state.calculadoraPgbl.clientsNameMap || {}
}
export const calculadoraPgblIrConfig = (state) => {
  return state.calculadoraPgbl.irConfig || null
}
export const calculadoraPgblIrAnosDisponiveis = (state) => {
  return state.calculadoraPgbl.irAnosDisponiveis || []
}
export const calculadoraPgblIrAnoSelecionado = (state) => {
  return state.calculadoraPgbl.irAnoSelecionado || null
}
export const openFinanceConnectors = (state) => {
  return state.openFinanceConnectors.data || []
}
export const openFinanceConnectorsMeta = (state) => {
  return state.openFinanceConnectors.meta || {}
}
export const openFinanceConnectorsLoading = (state) => {
  return state.openFinanceConnectors.loading
}
export const openFinanceConnectorsLastUpdate = (state) => {
  return state.openFinanceConnectors.lastUpdate
}
export const openFinanceClientConnectors = (state) => {
  return state.openFinanceClientConnectors.data || []
}
export const openFinanceClientConnectorsLoading = (state) => {
  return state.openFinanceClientConnectors.loading
}
export const openFinanceClientConnectorsLastUpdate = (state) => {
  return state.openFinanceClientConnectors.lastUpdate
}
export const openFinanceClientConnectorsClientId = (state) => {
  return state.openFinanceClientConnectors.clientId
}
export const receitasOuDespesas = (state) => {
  return state.receitasOuDespesas.data || []
}
export const receitasOuDespesasActive = (state) => {
  const raw = state.receitasOuDespesas.data
  let items = []
  if (Array.isArray(raw)) {
    items = raw
  } else if (raw && Array.isArray(raw.items)) {
    items = raw.items
  }
  return filterActiveReceitasDespesas(items)
}
export const receitasOuDespesasLoading = (state) => {
  return state.receitasOuDespesas.loading
}
export const receitasOuDespesasLastUpdate = (state) => {
  return state.receitasOuDespesas.lastUpdate
}
export const receitasOuDespesasClientId = (state) => {
  return state.receitasOuDespesas.clientId
}

export const simulacoes = (state) => {
  return state.simulacoes.data || []
}
export const simulacoesClientId = (state) => {
  return state.simulacoes.clientId
}
export const simulacoesLoading = (state) => {
  return state.simulacoes.loading
}
export const simulacoesLastUpdate = (state) => {
  return state.simulacoes.lastUpdate
}
export const relatoriosInterestRegistered = (state) => {
  return !!(state.preferences && state.preferences.relatoriosInterestRegistered)
}

// Getters do editor visual de relatório (Fase B.0.3 + B.0.5).
// Sempre retornam shape consistente — `secoes_ativas` como objeto e
// `comentario_consultor` como string — mesmo quando não há config para
// o cliente, evitando que o consumidor precise null-checkar.
export const relatorioConfigPorCliente = (state) => (clientId) => {
  if (!state.relatorioConfig || !state.relatorioConfig.porCliente || !clientId) {
    return {
      secoes_ativas: {},
      comentario_consultor: '',
      comentario_encerramento: '',
    }
  }
  const cfg = state.relatorioConfig.porCliente[clientId]
  if (!cfg) {
    return {
      secoes_ativas: {},
      comentario_consultor: '',
      comentario_encerramento: '',
    }
  }
  return {
    secoes_ativas: cfg.secoes_ativas || {},
    comentario_consultor: cfg.comentario_consultor || '',
    comentario_encerramento: cfg.comentario_encerramento || '',
  }
}

export const relatorioConfigEscritorio = (state) => {
  return (
    state.relatorioConfigEscritorio || {
      loading: false,
      loaded: false,
      secoes_ativas: {},
      comentario_consultor: '',
      comentario_encerramento: '',
    }
  )
}

export const relatorioConfigEscritorioLoaded = (state) => {
  return !!(state.relatorioConfigEscritorio && state.relatorioConfigEscritorio.loaded)
}

const _hasKeys = (obj) => {
  return obj && typeof obj === 'object' && Object.keys(obj).length > 0
}

/**
 * Cascade key-a-key: começa com office defaults e sobrescreve com qualquer
 * chave que o consultor tenha tocado por cliente. Assim o toggle pontual
 * de uma seção não invalida as escolhas default das demais.
 * O caller ainda mescla com os defaults hardcoded para garantir shape.
 */
export const relatorioSecoesAtivas = (state, getters) => (clientId) => {
  const office = getters.relatorioConfigEscritorio.secoes_ativas || {}
  const perClient = getters.relatorioConfigPorCliente(clientId).secoes_ativas || {}
  const merged = { ...office, ...perClient }
  if (_hasKeys(merged)) return merged
  return {}
}

/**
 * Cascade: per-cliente (string não vazia) → office default (string não vazia)
 * → ''. View renderiza placeholder com o texto-padrão hardcoded quando ''.
 */
export const relatorioComentarioConsultor = (state, getters) => (clientId) => {
  const perClient = getters.relatorioConfigPorCliente(clientId).comentario_consultor
  if (perClient) return perClient
  return getters.relatorioConfigEscritorio.comentario_consultor || ''
}

export const relatorioComentarioEncerramento = (state, getters) => (clientId) => {
  const perClient = getters.relatorioConfigPorCliente(clientId).comentario_encerramento
  if (perClient) return perClient
  return getters.relatorioConfigEscritorio.comentario_encerramento || ''
}

/**
 * Variantes "raw" — devolvem só o que está no slice per-cliente, sem
 * mesclar com office defaults. Usadas pelo editor visual para mostrar
 * o textarea vazio (placeholder com fallback) em vez do default já
 * herdado, para que o consultor saiba que está sobrescrevendo.
 */
export const relatorioSecoesAtivasRaw = (state, getters) => (clientId) => {
  return getters.relatorioConfigPorCliente(clientId).secoes_ativas
}

export const relatorioComentarioConsultorRaw = (state, getters) => (clientId) => {
  return getters.relatorioConfigPorCliente(clientId).comentario_consultor
}

export const relatorioComentarioEncerramentoRaw = (state, getters) => (clientId) => {
  return getters.relatorioConfigPorCliente(clientId).comentario_encerramento
}

/**
 * Lista de nomes de objetivos que o consultor desativou na seção
 * "Próximos Passos" — não vão para o painel "Por objetivo" do PDF.
 * Default: lista vazia (todos os objetivos cadastrados entram).
 */
export const relatorioObjetivosExcluidos = (state) => (clientId) => {
  if (!state.relatorioConfig || !state.relatorioConfig.porCliente || !clientId) {
    return []
  }
  const cfg = state.relatorioConfig.porCliente[clientId]
  if (!cfg || !Array.isArray(cfg.objetivos_excluidos)) return []
  return cfg.objetivos_excluidos
}
